// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"J3-z","dimensionLabel":"K3-z","styleChooserControlWrapper":"L3-z","styleChooserControl":"M3-z","disabled":"N3-z","giftCard":"O3-z","styleChooserText":"P3-z"};